import {uniqueId} from 'lodash'
import callStatusesBirthDays from '@/constants/callStatusesBirthDays'

const columns = [
  {
    type: 'checkbox',
    width: '30px'
  },
  {
    type: 'index',
    width: '37px'
  },
  {
    title: 'Nickname',
    prop: 'nickName',
    capitalize: true
  },
  {
    title: 'Phone',
    prop: 'phone',
    label: 'number',
    filterId: 'number',
    type: 'array',
    isSimpleShow: true,
  },
  {
    title: 'Email',
    prop: 'email',
    type: 'arrayPrimitive',
    label: 'email',
  },
/*  {
    title: 'First Name',
    prop: 'firstName',
    capitalize: true
  },
  {
    title: 'Last Name',
    prop: 'lastName',
    capitalize: true
  },*/
  {
    title: 'Birthday Date',
    prop: 'birthday',
    isIconCalendar: true,
    type: 'birthday',
    maskTitle: 'MMMM',
    disablePopupHeaderClick: true,
    filters: true,
    filterType: 'date',
    filterId: 'birthday',
    format: 'DD-MMM',
  },
  {
    title: 'Comment',
    type: 'comment',
    prop: 'comment'
  },
  {
    title: 'Status',
    type: 'toggleWithWarning',
    prop: 'isCongratulate',
    filters: callStatusesBirthDays,
    findIn: callStatusesBirthDays,
    filterId: 'isCongratulate',
  },
  {
    type: 'toolbar',
    status: 'comment',
    comment: 'comment',
    width: '25px'
  },
]

const prefix = 'contacts_tracking_birthdays_column_'
const trackingBirthdaysTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  item.route = {
    name: 'ContactCard',
    params: {
      id: 'id'
    }
  }
  return item
})

export {trackingBirthdaysTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsTrackingList/trackingBirthdaysTable.js